import { configureStore } from "@reduxjs/toolkit";
import ThemeSlice from "./ThemeSlice"; 
import LanguageSlice from "./LanguageSlice"; 


const Store= configureStore({
    reducer:{
        ThemeSlice:ThemeSlice, 
        LanguageSlice: LanguageSlice,
    }
})

export default Store;